import React, { useState, useEffect, useCallback } from "react";
import * as S from "./ModalConsultorStyle";
import Loading from "../../Loader";
import { useMessage } from "../../../Context/MessageContext";
import { consultorService } from "../../../Services/consultorService";
import {
  FaUser,
  FaIdCard,
  FaEnvelope,
  FaPhone,
  FaLock,
  FaTimes,
} from "react-icons/fa";

export default function ModalConsultor({ consultor, onClose }) {
  const { showMessage } = useMessage();
  const [formData, setFormData] = useState({});
  const [newPassword, setNewPassword] = useState("");
  const [load, setLoad] = useState(false);

  // Inicializa o formulário com os dados do consultor
  const resetForm = useCallback(() => {
    setFormData({
      name: consultor.name || "",
      email: consultor.email || "",
      cpfCnpj: consultor.cpfCnpj || "",
      phoneNumber: consultor.phoneNumber || "",
    });
    setNewPassword(""); // Limpa o campo de senha
  }, [consultor]);

  useEffect(() => {
    resetForm();
  }, [resetForm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleConfirm = async () => {
    setLoad(true);
    try {
      const dataToUpdate = { ...formData };

      // Só inclui a senha no payload se ela for preenchida
      if (newPassword.trim()) {
        dataToUpdate.password = newPassword;
      }

      await consultorService.updateConsultor(consultor.id, dataToUpdate);
      showMessage("Consultor atualizado com sucesso!", "success");
      onClose(true); // O 'true' sinaliza que houve uma atualização
    } catch (error) {
      console.error("Erro ao editar consultor:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Não foi possível atualizar o consultor.";
      showMessage(errorMessage, "error");
    } finally {
      setLoad(false);
    }
  };

  return (
    <S.ModalOverlay onClick={() => onClose(false)}>
      <S.ModalContainer size="medium" onClick={(e) => e.stopPropagation()}>
        <Loading load={load} />
        <S.ModalHeader>
          <h3>Editar Consultor #{consultor.id}</h3>
          <S.CloseButton onClick={() => onClose(false)}>
            <FaTimes />
          </S.CloseButton>
        </S.ModalHeader>

        <S.ModalBody>
          <S.InputGrid>
            <S.InputGroup>
              <label htmlFor="name">Nome Completo</label>
              <div className="input-wrapper">
                <FaUser />
                <input
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </div>
            </S.InputGroup>

            <S.InputGroup>
              <label htmlFor="email">Email</label>
              <div className="input-wrapper">
                <FaEnvelope />
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
            </S.InputGroup>

            <S.InputGroup>
              <label htmlFor="cpfCnpj">CPF/CNPJ</label>
              <div className="input-wrapper">
                <FaIdCard />
                <input
                  id="cpfCnpj"
                  name="cpfCnpj"
                  value={formData.cpfCnpj}
                  onChange={handleInputChange}
                />
              </div>
            </S.InputGroup>

            <S.InputGroup>
              <label htmlFor="phoneNumber">Telefone</label>
              <div className="input-wrapper">
                <FaPhone />
                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
            </S.InputGroup>

            <S.InputGroup className="full-width">
              <label htmlFor="newPassword">Redefinir Senha (opcional)</label>
              <div className="input-wrapper">
                <FaLock />
                <input
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Deixe em branco para não alterar"
                />
              </div>
            </S.InputGroup>
          </S.InputGrid>
        </S.ModalBody>

        <S.ModalFooter>
          <S.CancelButton onClick={() => onClose(false)}>
            Cancelar
          </S.CancelButton>
          <S.SaveButton onClick={handleConfirm}>Salvar Alterações</S.SaveButton>
        </S.ModalFooter>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
